/*
 *
 * SplitSchemeConfiguration constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/SplitSchemeConfiguration';
export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const SEARCH_CONFIGURATIONS = `${BASE_ACTION_CONSTANT}/SEARCH_CONFIGURATIONS`;

export const SAVE_CONFIGURATIONS = `${BASE_ACTION_CONSTANT}/SAVE_CONFIGURATIONS`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const CREATE_SPLIT_SCHEME = `${BASE_ACTION_CONSTANT}/CREATE_SPLIT_SCHEME`;

export const DELETE_SPLIT_SCHEME = `${BASE_ACTION_CONSTANT}/DELETE_SPLIT_SCHEME`;

export const GET_ALL_TERMINAL_ID = `${BASE_ACTION_CONSTANT}/GET_ALL_TERMINAL_ID`;
export const SAVE_ALL_TERMINAL_ID = `${BASE_ACTION_CONSTANT}/SAVE_ALL_TERMINAL_ID`;

export const GET_VENDOR_BY_ID = `${BASE_ACTION_CONSTANT}/GET_VENDOR_BY_ID`;

export const GET_STATIC_SPLIT_STATUS = `${BASE_ACTION_CONSTANT}/GET_STATIC_SPLIT_STATUS`;
export const SAVE_STATIC_SPLIT_STATUS = `${BASE_ACTION_CONSTANT}/SAVE_STATIC_SPLIT_STATUS`;

export const SPLIT_MODAL = 'split-modal';
export const DELETE_MODAL = 'delete-modal';
export const EDIT_MODAL = 'edit-modal';

export const FIXED = 'Fixed';
export const DYNAMIC = 'Dynamic';

export const SPLIT_SCHEME = 'split-scheme';

export const EPOS = 'EPOS';
export const STATIC_QR = 'STATIC_QR';
export const PG = 'PG';
export const SBC = 'SBC';

export const HEADINGS = [
  {
    key: 'createdAt',
    displayName: 'Created At',
    width: 0.3,
  },
  {
    key: 'product',
    displayName: 'Product',
    width: 0.2,
  },
  {
    key: 'terminalRefId',
    displayName: 'Reference ID',
    width: 0.3,
  },
  {
    key: 'terminalId',
    displayName: 'Product ID',
    width: 0.3,
  },
  {
    key: 'splitType',
    displayName: 'Split Type',
    width: 0.2,
  },
  {
    key: 'scheme',
    displayName: 'Split Scheme',
    width: 0.3,
  },
  {
    key: 'button',
    display: '',
    width: 0.1,
    align: 'right',
  },
];

export const SEARCH_SPLIT_SCHEME = {
  url: '/pg/settlements/split/static-split',
  method: 'GET',
};

export const CREATE_SPLIT_SCHEME_URL = {
  url: '/pg/settlements/split/static-split',
  method: 'POST',
};

export const GET_ALL_TERMINAL_ID_URL = {
  url: '/pg/subscriptions',
  method: 'GET',
};

export const PRODUCT_MAPPER = {
  EPOS: 'EPOS',
  STATIC_QR: 'Static QR',
  PG: 'Payment Gateway',
  SBC: 'Subscription',
};

export const vendorSplitStructure = {
  merchantVendorId: '',
  percentage: '',
};

export const radioData = {
  fieldLabel: 'Split Type',
  radioOptions: [
    {
      label: DYNAMIC,
      name: 'selected',
      value: false,
    },
    {
      label: FIXED,
      name: 'selected',
      value: true,
    },
  ],
};
